<template>
    <div class="ds-main-header-actions">
        <!-- <div class="px-2 cursor-pointer text-gray hover:text-darkblue">
            <icon>
                <IconSettings />
            </icon>
        </div>
        <div class="px-2 cursor-pointer text-gray hover:text-darkblue">
            <icon>
                <IconMailPoint />
            </icon>
        </div> -->
        <div class="ds-header-user-menu-wrapper" v-click-outside="closeMenu">
            <div class="ds-main-header-user ds-header-user-trigger" @click="toggleMenu">
                <User :first-name="firstName" :last-name="lastName" :avatar v-if="store.userInfo" />
            </div>
            <div v-if="isMenuOpen" class="ds-header-user-menu z-[60]">
                <button class="ds-header-user-menu-item" type="button" @click="onProfileClick">
                    <icon width="16" height="16" vb-size="24" class="mr-2 shrink-0"><IconProfile /></icon>
                    Профиль
                </button>
                <button class="ds-header-user-menu-item" type="button" @click="openSupportModal">
                    <icon width="16" height="16" vb-size="24" class="mr-2 shrink-0"><IconHelp /></icon>
                    Поддержка
                </button>
                <div class="ds-header-user-menu-divider" aria-hidden="true"></div>
                <button class="ds-header-user-menu-item ds-header-user-menu-item-danger" type="button" @click="openLogoutConfirm">
                    Выйти из профиля
                </button>
            </div>
        </div>

        <ConfirmDialog
            v-model="isConfirmOpen"
            title="Выйти из профиля?"
            text="Вы действительно хотите выйти из профиля?"
            confirm-text="Выйти"
            @confirm="LogOut"
        />

        <modal v-if="isSupportModalOpen" @close="closeSupportModal">
            <div class="relative max-w-[90vw] max-h-[80vh]">
                <button
                    class="absolute right-0 top-0 z-10 flex h-8 w-8 items-center justify-center text-gray hover:text-darkblue"
                    type="button"
                    aria-label="Закрыть форму поддержки"
                    @click="closeSupportModal"
                >
                    <icon width="20" height="20"><IconClose /></icon>
                </button>
                <div ref="feedbackFormContainer" class="max-h-[80vh] overflow-auto pr-10"></div>
            </div>
        </modal>
    </div>
</template>

<script setup lang="ts">
import { computed, nextTick, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
// import IconSettings from '../../ui/icons/IconSettings.vue'
// import IconMailPoint from '../../ui/icons/IconMailPoint.vue'
import User from '../User.vue'
import { useAuthStore } from '@/stores/authStore'
import ConfirmDialog from '@/ui/ConfirmDialog.vue'
import IconClose from '@/ui/icons/IconClose.vue'
import IconHelp from '@/ui/icons/IconHelp.vue'
import IconProfile from '@/ui/icons/IconProfile.vue'

const store = useAuthStore()
const route = useRoute()

const firstName = computed(() => store.userInfo?.first_name)
const lastName = computed(() => store.userInfo?.last_name)
const avatar = computed(() => store.userInfo?.avatar)

const isMenuOpen = ref(false)
const isConfirmOpen = ref(false)
const isSupportModalOpen = ref(false)
const feedbackFormContainer = ref<HTMLDivElement | null>(null)

const youTrackFormId = '9d92f1ae-9edc-47dc-8083-aee2e89bd8dc'
const youTrackOrigin = 'https://yt.mindm.ru'

const mountYouTrackForm = () => {
    const container = feedbackFormContainer.value

    if (!container) return

    const script = document.createElement('script')
    script.id = youTrackFormId
    script.dataset.ytUrl = youTrackOrigin
    script.src = `${youTrackOrigin}/static/simplified/form/form-entry.js`
    script.dataset.theme = 'light'
    script.dataset.lang = 'ru'
    script.onerror = () => console.error('Не удалось загрузить форму обратной связи YouTrack')

    container.replaceChildren(script)
}

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
    isMenuOpen.value = false
}

const onProfileClick = () => {
    closeMenu()
}

const openSupportModal = async () => {
    closeMenu()
    isSupportModalOpen.value = true
    await nextTick()
    mountYouTrackForm()
}

const closeSupportModal = () => {
    isSupportModalOpen.value = false
}

const openLogoutConfirm = () => {
    closeMenu()
    isConfirmOpen.value = true
}

const LogOut = () => store.logOut()

watch(() => route.fullPath, () => closeMenu())
</script>
